import { z } from "zod";

export const contractCommitmentSendPayloadSchema = z.object({
  contract_id: z.string().min(1),
  customer: z.string().min(1),
  template: z.string().min(1),
  arr: z.number().nonnegative(),
  currency: z.enum(["USD", "EUR", "GBP", "ILS"]),
  changed_clauses: z.array(z.string()),
  regulated_data: z.boolean(),
  send_external: z.boolean()
});

export type ContractCommitmentSendPayload = z.infer<typeof contractCommitmentSendPayloadSchema>;
